import axios from './axios';

const getWebEvent = (eventId, currentLanguage) => {
  return axios.get(`/api/events/${eventId}`, {
    headers: {
      'Accept-Language': currentLanguage,
    },
  });
};

export { getWebEvent };
